export const HELPER_ICON_NO = 0;
export const HELPER_ICON_INFORMATION = 1;
export const HELPER_ICON_QUESTION = 2;
export const HELPER_ICON_WARNING = 3;
export const HELPER_ICON_ERROR = 4;

export const HELPER_BUTTON_ABORT = "abort";
export const HELPER_BUTTON_CANCEL = "cancel";
export const HELPER_BUTTON_CHECK_UPDATE = "check_update";
export const HELPER_BUTTON_CONTINUE = "continue";
export const HELPER_BUTTON_DOWNLOAD_UPDATE = "download_update";
export const HELPER_BUTTON_INSTALL_UPDATE = "install_update";
export const HELPER_BUTTON_OK = "ok";
export const HELPER_BUTTON_RETRY = "retry";
export const HELPER_BUTTON_SKIP = "skip";

export const HELPER_MESSAGE_IDLE = 1;
export const HELPER_MESSAGE_IDLE_ABORTED_DOWNLOAD = 2;
export const HELPER_MESSAGE_IDLE_ABORTED_INSTALLATION = 3;
export const HELPER_MESSAGE_CHECKING_FOR_UPDATE = 10;
export const HELPER_MESSAGE_NEW_UPDATE_AVAILABLE = 11;
export const HELPER_MESSAGE_NO_UPDATE_AVAILABLE = 12;
export const HELPER_MESSAGE_ERROR_DURING_CHECKING = 14;
export const HELPER_MESSAGE_SYNCHRONIZING_DATABASES = 15;
export const HELPER_MESSAGE_DOWNLOADING_PACKAGE = 20;
export const HELPER_MESSAGE_VERIFYING_PACKAGE = 21;
export const HELPER_MESSAGE_DOWNLOADING_FAILED = 22;
export const HELPER_MESSAGE_VERIFICATION_FAILED = 23;
export const HELPER_MESSAGE_START_INSTALLATION = 24;
export const HELPER_MESSAGE_AUTOMATIC_INSTALLATION = 25;
export const HELPER_MESSAGE_STOPPING_SERVICES = 40;
export const HELPER_MESSAGE_COPYING_FILES = 41;
export const HELPER_MESSAGE_STARTING_SERVICES = 42;
export const HELPER_MESSAGE_UPDATE_FINISHING = 43;
export const HELPER_MESSAGE_UPDATE_DONE = 44;
export const HELPER_MESSAGE_UPDATE_FAILED = 45;
export const HELPER_MESSAGE_REBOOT_REQUIRED = 46;
export const HELPER_MESSAGE_GENERIC_ERROR = 999;

export const HELPER_CHUNK_SIZE = 100000;

export const HELPER_SIZE_KB = 1024;
export const HELPER_SIZE_MB = HELPER_SIZE_KB * HELPER_SIZE_KB;
export const HELPER_SIZE_GB = HELPER_SIZE_MB * HELPER_SIZE_KB;
export const HELPER_SIZE_TB = HELPER_SIZE_GB * HELPER_SIZE_KB;
